import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim is grounded in EAKC-MVP: migrations 009/033/034 + docs/content/02 §"March 2026".

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.4, caption: "I shipped hybrid search. Then I found 30% of my relevance score had been returning zero — for weeks." },
];

export const PROBLEM: ScriptLine[] = [
  { scene: "problem", fromSec: 0.4, holdSec: 5.5, caption: "Vector search ranks by meaning — so an exact term like a function name gets buried under things that are merely related." },
  { scene: "problem", fromSec: 6.2, holdSec: 6, caption: "That’s why you add keyword search (BM25) as 30% of the score." },
  { scene: "problem", fromSec: 12.5, holdSec: 6.5, caption: "But mine silently returned 0. plainto_tsquery uses AND — a 5-word question matched no single chunk." },
];

export const INTUITION: ScriptLine[] = [
  { scene: "intuition", fromSec: 0.4, holdSec: 5.5, caption: "Search the library two ways at once: by meaning, AND by the exact words." },
  { scene: "intuition", fromSec: 6.2, holdSec: 5, caption: "Then fuse the two rankings into one." },
];

export const APPROACH: ScriptLine[] = [
  { scene: "approach", fromSec: 0.4, holdSec: 6, caption: "Migration 009: one Postgres function runs both signals and fuses them." },
  { scene: "approach", fromSec: 7, holdSec: 6.5, caption: "Vector weighted 0.7, lexical 0.3 — each over-fetched 3×, then re-ranked." },
];

export const CODE: ScriptLine[] = [
  { scene: "code", fromSec: 0.5, holdSec: 6, caption: "Two CTEs: cosine distance over the embedding, and ts_rank_cd over the tsvector." },
  { scene: "code", fromSec: 7, holdSec: 7.5, caption: "One weighted score fuses them. Real SQL — not a framework abstraction." },
  { scene: "code", fromSec: 15, holdSec: 8, caption: "The bug hid here: plainto_tsquery. AND-semantics meant the lexical half was dead." },
];

export const PAYOFF: ScriptLine[] = [
  { scene: "payoff", fromSec: 0.4, holdSec: 5.5, caption: "Migration 033 swapped it for an OR-tsquery. BM25 went from 0 results to 15–20." },
  { scene: "payoff", fromSec: 6.2, holdSec: 6, caption: "Migration 034 split camelCase identifiers in the index — breaking the 85% ceiling." },
  { scene: "payoff", fromSec: 12.5, holdSec: 6.5, caption: "Code-query accuracy: ~75% → peak 90%. One SQL fix, a 10-point jump." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5, caption: "Vector-only misses keywords. Keyword-only misses meaning. You need both — and you need to check both actually fire." },
  { scene: "outro", fromSec: 6, holdSec: 4, caption: "Next: the ten fixes that took my code RAG from 75% to 90%." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
